import * as types from '../actiontypes';
import {API_RESOURCES, createApiCreateAction, createApiReadAction} from '../../util/api';

export function addApprovalForDocument(url, data, trackWithArea) {
	const action = {
		type: types.ADD_APPROVAL,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data,
				trackWithArea
			}
		}
	};

	return action;
}

export function setApprovalsFromDocument(approvals, documentId) {
	return {
		type: types.SET_APPROVALS,
		approvals: approvals,
		documentId: documentId
	};
}
export function createCanvasFormSnapshot(url, data) {
	return {
		type: types.CREATE_SNAPSHOT,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: data
			}
		}
	};
}

export function deleteApprovalForDocument(url, data, trackWithArea) {
	return {
		type: types.DELETE_APPROVAL,
		resolve: true,
		meta: {
			api: {
				url: url,
				method: 'DELETE',
				data: data,
				trackWithArea
			}
		}
	};
}

export function getDocumentSignOffs(url, documentId) {
	return {
		type: types.GET_DOCUMENT_SIGN_OFFS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				documentId: documentId
			}
		}
	};
}

export function handOffTask(engagementId, taskId, payload, currentAssignment) {
	return createApiCreateAction(
		types.HANDOFF_TASK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: taskId,
			[API_RESOURCES.HANDOFFS]: undefined
		},
		payload,
		{taskId, ...currentAssignment}
	);
}

export function getTaskAssignments(engagementId, taskId) {
	return createApiReadAction(
		types.GET_TASK_ASSIGNMENTS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: taskId,
			[API_RESOURCES.ASSIGNMENTS]: undefined
		},
		{
			AssignedTo: 'TaskAssignments'
		},
		{
			taskId
		}
	);
}
